import request from '@/utils/request';

// 添加简历
export function addResume(data) {
  return request.post('api/Res.Resume/add', data, { authRequired: true });
}

// 简历内容
export function detailResume(data) {
  return request.get('api/Res.Resume/view', { params: data, authRequired: true });
}

// 更新简历
export function updateResume(data) {
  return request.post('api/Res.Resume/update', data, { authRequired: true });
}

// 获取选项
export function getOptions() {
  return request.post('api/Res.ResumeData/index');
}
